<template>
    <div class="input-group phone-number d-flex">
        <!-- TYPE -->
        <select
            class="form-select px-2"
            :disabled="disabled"
            v-if="!singleOption"
            @change.prevent="updateType"
            @blur="emitBlur"
            v-model="type"
        >
            <option v-for="option in phoneOptions" :value="option.value" :key="option.value">{{ option.name }}</option>
        </select>
        <!-- COUNTRY -->
        <div v-if="enableCountry && countryList.length > 0" class="btn-group" id="CountryDropdown" role="group">
            <button
                id="CountryButton"
                type="button"
                data-bs-toggle="dropdown"
                :class="`btn dropdown-toggle border ${disabled ? 'disabled' : ''} ${singleOption ? 'border-left' : ''}`"
                :disabled="disabled"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <span :class="`flag-icon fi-${selectedCountry?.twoLetterCode?.toLowerCase()} me-1`"></span>
                <span>{{ selectedCountry.phoneCode }}</span>
            </button>
            <ul class="dropdown-menu" aria-labelledby="CountryButton">
                <li
                    v-for="country in countryList"
                    :class="`dropdown-item ${country.value === selectedCountry.value ? 'highlight-item' : ''}`"
                    :key="country.value"
                    @click="handleCountrySelection(country)"
                >
                    <span :class="`flag-icon fi-${country.twoLetterCode?.toLowerCase()} me-1`"></span>
                    <span>{{ country.name }}</span>
                    <span class="phone-code font-size-xs">{{ country.phoneCode }}</span>
                </li>
            </ul>
        </div>
        <!-- INPUT -->
        <input
            type="text"
            class="form-control phone-number-input"
            :value="formattedNumber"
            @input="valueUpdated(($event.target as any).value)"
            maxlength="14"
            :placeholder="placeholder"
            :disabled="disabled"
            @blur="emitBlur"
            v-if="!enableCountry || isUnitedStates"
        />
        <input
            type="text"
            class="form-control phone-number-input"
            :value="value"
            @input="valueUpdated(($event.target as any).value)"
            maxlength="14"
            :placeholder="placeholder"
            :disabled="disabled"
            @blur="emitBlur"
            v-else
        />
        <!-- EXTENSION -->
        <input
            type="text"
            class="form-control"
            @input="updateExtension(($event.target as any).value)"
            :disabled="disableExtensionLocal || disabled"
            :value="extension"
            placeholder="Extn."
            maxlength="5"
            v-if="showExtension"
        />
    </div>
</template>

<style src="./PhoneNumber.scss"></style>

<script lang="ts" src="./PhoneNumber.ts"></script>
